import React from "react";

export function PaymentStickyBar({
  amountLabel,
  amount,
  buttonLabel,
  disabled,
  onClick,
  formId,
  amountSuffix,
  note,
}: {
  amountLabel: string;
  amount: string;
  /** "/mês" or "/ano" when the amount is what renews; left out for a prorated or discounted charge. */
  amountSuffix?: string;
  buttonLabel: string;
  disabled?: boolean;
  onClick?: () => void;
  /** When set, the button submits this form (for checkout). */
  formId?: string;
  /**
   * Stacked layout (checkout): this line, small and centred, above a full-width button —
   * the same bar as the plans page, so a long amount ("12x de R$ 25,00") is never cut.
   */
  note?: string;
}) {
  if (note) {
    return (
      <div className="integrated-sticky-bar lg:hidden">
        <div className="max-w-5xl mx-auto grid gap-1.5">
          <div className="text-xs text-center text-ink-2">{note}</div>
          <button
            type={formId ? "submit" : "button"}
            form={formId}
            className="btn-primary w-full py-3"
            disabled={disabled}
            onClick={onClick}
          >
            {buttonLabel}
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="integrated-sticky-bar lg:hidden">
      <div className="flex items-center gap-3 max-w-5xl mx-auto">
        <div className="flex-1 min-w-0">
          <div className="text-[10px] uppercase tracking-widest text-ink-2">{amountLabel}</div>
          <div className="text-xl font-semibold truncate" style={{ letterSpacing: "-0.02em" }}>
            {amount}
            {amountSuffix && <span className="text-sm font-normal text-ink-2">{amountSuffix}</span>}
          </div>
        </div>
        <button
          type={formId ? "submit" : "button"}
          form={formId}
          className="btn-primary shrink-0 px-5 py-3"
          disabled={disabled}
          onClick={onClick}
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
}
